import { LineItem, PaymentLineItem, PaymentMethod, PaymentMethodCopy, Seller, SellerPaymentMethod } from "types";

export const isCommentAllowed = (seller: Seller, paymentMethod: ID) => {
    const methods = seller.paymentMethods ?? [];
    const method = methods.find((pm) => pm.id === paymentMethod);
    return (method?.comment?.enabled && method?.comment?.enabled) ?? false;
};

export const getPaymentMethodName = (seller: Seller, method: PaymentMethod | ID) => {
    const realMethod: PaymentMethod = method as PaymentMethod; // For preventing lint errors

    if (PaymentMethodCopy[realMethod]) {
        return PaymentMethodCopy[realMethod];
    }

    return seller.paymentMethods?.find(({ id }) => id === method)?.name;
};

export const isCreditCardPayment = (paymentMethod: SellerPaymentMethod | null) => {
    return paymentMethod?.id === PaymentMethod.CREDIT_CARD;
};

export const isCreditCardPaymentLineItem = (lineItem: LineItem | PaymentLineItem) => {
    return lineItem.payment?.method === PaymentMethod.CREDIT_CARD;
};

export const isCreditCardSummary = (lineItem: PaymentLineItem) => {
    return lineItem.payment?.meta?.cardSummary;
};
